import { defineComponent as _defineComponent } from 'vue'
import { useValidator } from '@/core/app.service';
import { useTranslations } from '@/core/translate.mixin';
import { useNewsletter } from '@/store/newsletter.composable';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpDiscountPopupPermissionForm',
  emits: ["submit"],
  setup(__props, { emit }: { emit: ({(e: 'submit', email: string): void}), expose: any, slots: any, attrs: any }) {



const displayErrors = ref<boolean>(false);
const submittingFormData = ref<boolean>(false);
const submitError = ref<boolean>(false);
const request = ref<SignUpDiscountEmailWebRequest>({
    email: '',
    marketingFlagAccepted: false,
    profilingFlagAccepted: false
});

const { privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText, submitSignUpDiscountForm } = useNewsletter();

const $validator = useValidator();
const { t } = useTranslations();

onMounted(() => {
    const dictionary = {
        custom: {
            email: {
                required: t('Pages.SignUpDiscount.SignUpDiscountEmailFormPopUp.EmailRequiredErrorMessage'),
                email: t('Pages.SignUpDiscount.SignUpDiscountEmailFormPopUp.EmailInvalidErrorMessage')
            }
        }
    };
    $validator.localize('en', dictionary);
});

async function submitPermission() {
    const isValid = await $validator.validateAll();
    if (isValid) {
        submittingFormData.value = true;
        try {
            const response = await submitSignUpDiscountForm(request.value);
            if (response !== null) {
                submitError.value = false;
                displayErrors.value = false;
                emit('submit', request.value.email);
            } else {
                submitError.value = true;
                displayErrors.value = true;
            }
        } catch {
            submitError.value = true;
            displayErrors.value = true;
        }
        submittingFormData.value = false;
    } else {
        displayErrors.value = true;
    }
}


return { __sfc: true,emit, displayErrors, submittingFormData, submitError, request, privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText, submitSignUpDiscountForm, $validator, t, submitPermission }
}

})